import styled from 'styled-components';
import { useRouter } from 'next/router';
import Footer from '@/components/Footer';
import Nav from './Nav';
import GoogleAnalytics from '@/components/GoogleAnalytics';
import Header from '@/components/Header';
import { useContext } from 'react';
import { DarkModeContext } from '@/pages/_app';

const Container = styled.div`
  min-height: 100vh;
`;

type Props = {
  title: string;
  description: string;
  children: React.ReactNode;
};

const Layout: React.FC<Props> = ({ title, description, children }) => {
  const { darkMode } = useContext(DarkModeContext);
  function backGroundColour() {
    return darkMode === 'light'
      ? { backgroundColor: '#faf1e7', paddingBottom: '5rem' }
      : { backgroundColor: '#a9a8a8', paddingBottom: '5rem' };
  }
  const router = useRouter();
  function showNav() {
    return router.pathname !== '/' && <Nav />;
  }
  return (
    <>
      <GoogleAnalytics />
      <Header title={title} description={description} />
      {showNav()}
      <div style={backGroundColour()}>
        <main style={backGroundColour()}>
          <Container>{children}</Container>
        </main>
      </div>
      <Footer />
    </>
  );
};

export default Layout;
